module.exports = __webpack_public_path__ + "eca9779bc8b747c3203fd04489c244c9.jpg";